import type { IconData } from '@stacksjs/iconify-core'

export const glueF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 9H2V7.393a1 1 0 0 1 1-1h1v-5a1 1 0 1 1 2 0v5h1a1 1 0 0 1 1 1zm.809 1A3 3 0 0 1 10 12.393v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7c0-.977.467-1.845 1.191-2.393z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default glueF
